<template>
<!--  <div id="container" ref="mapRef" class="mainBox"></div>-->
  <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
<div class="mainBox">
	<!-- 标题 -->
  <nyTit pathUrl='/plant' />
  <div class="content">
    <!--   左边开始-->
    <div class="maps_lefts">
      <div class="maps_lefts_l">
        <div class="subTit1"><span>项目总览</span></div>
        <div class="maps_lefts_img"><img :src="state.left_data[0].header" /></div>
        <div class="maps_lefts_txt">{{state.txt1}}</div>
        <div class="maps_lefts_fgx"></div>
        <div class="maps_lefts_txt">{{state.txt2}}</div>
      </div>
      <div class="maps_lefts_r">
        <div class="maps_lefts_rBox1">
          <div class="subTit1"><span>产业带动情况</span></div>
          <div class="map_txt_c"><LeftPie /></div>
        </div>
        <div class="map_gk">
          <div class="subTit1"><span>产业概况</span></div>
          <div class="map_txt_c"><LeftBar/></div>
        </div>
      </div>
    </div>
    <div class="center"><div class="mapBox"><div class="map" ref="mapRef"></div></div><div class="maps_bottoons"><navItem /></div></div>
    <!--  中间开始-->



    <!-- 右边开结束 -->

    <div class="maps_rights">
      <div class="right1">
      <div class="subTit1 subTit2"><span>行情走势</span></div>
        <div class="right1Top"><div class="right1Item" v-for="(item,index) in state.rightData1" :key="index"><span>{{item.name}}</span><span>{{item.value}}<i>{{item.unit}}</i></span></div></div>
        <div class="right2Bottom">
          <div class="right_bottom_left">
            <h5>项目巡查</h5>
            <div class="right_bottom_info">
              <div class="right_bottom_item" v-for="(item,index) in state.rightData2" :key="index">
                <h6>{{item.value}}</h6>
                <span>{{item.name}}</span>
                <img :src="item.icon" />
              </div>
            </div>
          </div>
          <div class="right_bottom_right">
            <h5>项目巡查未整改警示</h5>
            <div class="right_bottom_info"><dv-scroll-board :config="state.config"/></div>
          </div>
        </div>
      </div>
      <div class="right2">
        <div class="subTit1 subTit2"><span>视频巡检</span></div>
        <div class="videoBox">
          <div class="videoItem"  v-for="(item, index) in state.left_data1"
               :key="index"  @click="videoClick(index)">
            <img :src="item.header" />
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- 底部导航 -->

 <popBg :title="state.videoList[state.curVideoIndex].name" style="z-index: 99999;" :popShow="state.popShow" @hiddlen="popHiddlen">
    <vue3VideoPlay
      id="video"
      width="100%"
      height="100%"
      title="冰河世纪"
      :src="state.videoList[state.curVideoIndex].options.src"
      :type="state.videoList[state.curVideoIndex].options.type"
      :autoPlay="true"
    />
  </popBg>

  <!-- 底部导航 -->
  <!-- <footer1 /> -->
</div>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";

// todo 项目使用请放开 leaflet 引入
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet/dist/leaflet.esm.js';
import Gep from "../utils/范围面.json";

import nyTit from "../components/nyTit.vue";
import navItem from '@/components/nyNav'
import popBg from "../components/popBg.vue";
import LeftBar from "../components/gbzntyj/LeftBar"
import LeftPie from "../components/gbzntyj/leftPie.vue"

    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
	    videoList: [
	      {
          name: "视频巡检1",
          options: {
            src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/3.mp4", //视频源
            type: "video/mp4", //视频类型
          },
	      },
	      {
          name: "视频巡检2",
          options: {
            src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/9.mp4", //视频源
            type: "video/mp4", //视频类型
          },
	      },
	    ],
	    curVideoIndex: 0,
	    popShow: false,
	    left_data: [
	      {header: require("../assets/img/newxmzl/t1.png")},
	      // {header: require("../assets/img/newxmzl/t2.png"),}
	    ],
      left_data1: [
        {header: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/3.png"},
        {header: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/9.png"},
      ],
	    txt1:"上蔡县高标准农田示范区作为一项惠民工程，以高效、节水、智能、绿色、生态为建设目标，将物联网、大数据、云计算与固定式喷灌、半固定式喷灌、绞盘式喷灌、平移式喷灌、微喷式喷灌系统有机融合，特别是利用北汝河的地表水进行灌溉，更符合高标准农田灌溉建设要求。项目建成后，将成为一流的物联网、智能化的高标准农田灌溉示范区，真正实现“藏粮于地、藏粮于技”，对提高全县农业基础设施建设水平，加快现代农业发展，促进乡村振兴具有重要意义。",
	    txt2:"小麦种植示范田:依托西南部现状农田，结合小麦示范园高标准打造小麦种植示范田，也作为园区特色农业对外形象的展示平台，农田总面积约4.5公顷(约67.5亩)",
      rightData1:[
        {name:"项目总数",value:"89",unit:"个"},
        {name:"项目投资",value:"89",unit:"亿元"},
        {name:"建成项目",value:"89",unit:"个"},
        {name:"在建项目",value:"89",unit:"个"},
      ],
      rightData2:[
        {name:"正常",value:689,icon:require('../assets/img/newxmzl/icon1.png')},
        {name:"整改",value:3,icon:require('../assets/img/newxmzl/icon2.png')},
        {name:"未整改",value:3,icon:require('../assets/img/newxmzl/icon3.png')}
      ],
      config: {
        header: [],

        data: [
          ["XXXX地块项目：LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格"],
          ["XXXX地块项目：LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格"],
          ["XXXX地块项目：LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格"],
          ["XXXX地块项目：LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格"],
          ["XXXX地块项目：LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格"],
          ["XXXX地块项目：LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格LED屏幕检验不合格"],
        ],
        headerBGC:"",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        align: ["left"],
        // headerHeight:90,
        rowNum:6
      },


    });

    const emit = defineEmits(["mapLoad"]);
    const boundaryData = Gep;
    console.log(boundaryData);

    const marker = ref();
    const map = ref(null);
    let current = ref(0);

    // 地图底图
    // 第一种
    let mapType = ref("vec");
    let mapLabelType = ref("cva");

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&x={x}&y={y}&z={z}",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );
    let mapType1 = ref(
      L.tileLayer(
        "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );

    let mapLabelType1 = ref(
      L.tileLayer(
        "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );

    const initMap = () => {
      map.value.addLayer(mapType1.value);
      map.value.addLayer(mapLabelType1.value);
      map.value.on("click", ({ latlng }) => {
        console.log("坐标：", Object.values(latlng));
      });

      return map.value;
    };

    const mapObj = ref();

    // 在 onMounted 中初始化地图
    onMounted(() => {
      map.value = L.map(mapRef.value, {
        center: [33.24651210282269, 114.16751861572267],

        // center: [114.182633, 33.240019],
        zoom: 14,
        minZoom: 3,
        maxZoom: 19,
        noWrap: true,
        // dragging: false,
        zoomControl: true,
        attributionControl: false,
      });
      mapObj.value = initMap();
      // createMarkers();
      loadBoundary();
    });

    function createDashedPolyline(feature, style) {
      const latLngs = feature.geometry.coordinates;
      if (feature.geometry.type === "Polygon") {
        // 取外圈线作为多段线处理
        latLngs = [latLngs[0]];
      } else if (feature.geometry.type === "MultiPolygon") {
        // 处理多个多边形，这里仅取第一个外圈线
        latLngs = [latLngs[0][0]];
      }

      const options = {
        ...style,
        dashArray: [5, 5], // 虚线长度与间距
        lineCap: "round", // 线头样式，可选
        lineJoin: "round", // 线交接处样式，可选
      };

      return L.polyline(latLngs, options);
    }

    // 添加行政区划边界的逻辑
    const loadBoundary = () => {
      L.geoJSON(boundaryData, {
        onEachFeature: function (feature, layer) {
          let style;

          switch (feature.properties.T) {
            case "未建成":
              style = {
                color: "green",
                fillColor: "green",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            case "其他":
              style = {
                color: "green",
                fillColor: "green",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            default:
              style = {
                color: "white",
                fillColor: "red",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
          }

          if (
            feature.geometry.type === "Polygon" ||
            feature.geometry.type === "MultiPolygon"
          ) {
            // 设置填充样式
            layer.setStyle(style);

            // 处理每个外环线为虚线
            feature.geometry.coordinates.forEach((ring, index) => {
              if (index === 0 || feature.geometry.type === "Polygon") {
                // 对于多边形，只处理外环线
                const dashedLine = createDashedPolyline(
                  { geometry: { coordinates: [ring] } },
                  style
                );
                map.value.addLayer(dashedLine);
              }
            });
          } else if (
            feature.geometry.type === "LineString" ||
            feature.geometry.type === "MultiLineString"
          ) {
            const dashedLine = createDashedPolyline(feature, style);
            map.value.addLayer(dashedLine);
          }

          // 添加原始图层到地图上（用于显示填充区域）
          map.value.addLayer(layer);
        },
      }).addTo(map.value);
    };

    const removeMap = () => {
      if (mapObj.value) {
        mapObj.value.remove();
      }
    };

    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
 
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
    });
    onUnmounted(() => {
      removeMap();
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
	// 弹出视频
	function videoClick(index) {
	  console.log(index);
	  state.popShow = true;
	  state.curVideoIndex = index;
	}
	// 关闭弹出
	function popHiddlen() {
	  state.popShow = false;
	}
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state {
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon {
  font-size: 20px !important;
}
::v-deep .d-player-wrap .d-player-control {
  height: 30px;
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;
  .content {
    width: 100%;
    height: calc(100% - 200px);
    position: absolute;
    top: 200px;
    // border: #fff 1px solid;
    display: flex;
    padding-bottom: 100px;
    // 公共标题
    .subTit1{
      width: 100%;
      height: 130px;
      line-height: 40px;
      background: url("../assets/img/nyhongshu/bt3.png") no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      span{
        background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;
      }
    }
    .subTit2{
      height: 195px;
      line-height: 30px;
      background: url("../assets/img/nyhongshu/bt2.png") no-repeat;
    }
    .maps_lefts{
      width: 2110px;
      height: 100%;
      display: flex;
      .maps_lefts_l{
        width: 984px;
        height: 100%;
        margin: 0 64px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .maps_lefts_img{
          width: 971px;
          height:502px;
          background: url("../assets/img/newxmzl/imgbg1.png") no-repeat;
          background-size: 100% 100%;
          margin-top: -20px;
          img{
            width: 100%;
            height: 100%;
            padding: 20px 20px;
          }
        }

        .maps_lefts_txt{
          width: 90%;
          flex: 1;
          font-size: 30px;
          color: #fff;
          text-align: left;
          text-indent: 2em;
          line-height: 60px;
        }
        .maps_lefts_fgx{
          width: 90%;
          height: 30px;
          background: url("../assets/img/newxmzl/xk.png") no-repeat;
          background-size: 100% 100%!important;
          margin: 30px 0;

        }
      }
      .maps_lefts_r{
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        .maps_lefts_rBox1{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .map_gk{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .map_txt_c{
          width: 100%;
          flex: 1;

        }
      }
    }

    .maps_rights{
      width: 2110px;
      height:100%;
      display: flex;
      flex-direction: column;
      .right1{
        flex: 1;
        display: flex;
        flex-direction: column;
        .right1Top{
          display: flex;
          justify-content: space-between;
          height: 138px;
          padding: 0 150px;
          margin-top: -70px;
          .right1Item{
            width: 346px;
            height: 138px;
            background: url("../assets/img/newxmzl/righttop.png") no-repeat;
            font-size: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #00E0DB;
            span{
              display: block;
              i{font-size: 26px;margin-left: 10px;font-style: normal}
            }
            span:first-child{
              font-weight: bold;
              margin-bottom: 10px;
            }
          }
        }
        .right2Bottom{
          width: 100%;
          flex: 1;
          display: flex;
          padding: 30px 50px 30px 100px;
          h5{
            font-size: 36px;
            color: #00E0DB;
            text-align: left;
            //font-weight: normal;
          }
          .right_bottom_info{
            width: 100%;
            flex: 1;
            display: flex;
          }
          .right_bottom_left{
            flex: 1;
            display: flex;
            flex-direction: column;
            padding-right: 50px;
            h5{padding-left: 50px}
            .right_bottom_item{
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: 33%;
              h6{
                font-size: 32px;
                color: #00E0DB;
              }
              span{
                font-size: 30px;
                color: #fff;
                margin: 20px 0;
              }
              img{
                width: 255px;
                height: 173px;
              }
            }

          }
          .right_bottom_right{
            width:45%;
            display: flex;
            flex-direction: column;
            .right_bottom_info{
              padding: 30px 0;
            }
            ::v-deep .row-item{
              font-size: 30px;
              margin: 10px 0;
            }
          }
        }
      }
      .right2{
        height: 600px;
        display: flex;
        flex-direction: column;
        .videoBox{
          width: 100%;
          flex: 1;
          margin-top: -30px;
          display: flex;
          justify-content: space-between;
          padding: 0 80px;
          .videoItem{
            width: 934px;
            height: 465px;
            background: url("../assets/img/newxmzl/imgbg2.png") no-repeat;
            background-size: 100% 100%;
            border: 1px solid;
            img{
              width: 100%;
              height: 100%;
              padding: 20px 20px;
            }

          }

        }

      }
    }
    .center{
      flex: 1;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      .mapBox{
        width: 100%;
        flex: 1;
        background: rgba(42,130,96,0.06);
        box-shadow: inset 0px 1px 33px 0px rgba(29,143,110,0.5);
        border-radius: 7px;
        border: 1px solid #02D68B;
        padding: 30px;
        margin: 30px 0;
        .map{
          width: 100%;
          height: 100%;
        }
      }
      .maps_bottoons{
        width: 100%;
        height: 240px;
        padding: 0 100px;
      }
    }
    }



  }




@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(0.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
  100% {
    transform: rotate(0);
  }
}

#video .d-player-wrap .d-player-control {
  height: 50px;
}
</style>
